import useNav from "../../../uses/useNav";
import MyMDBox from "../../../components/MyMDBox";
import MyMDButton from "../../../components/MyMDButton";
import MyTableStyle from "../../../examples/MyTableStyle";
import { useEffect, useState } from "react";
import { T_elevError } from "../../../models/error";
import apis from "../../../apis";
import MyMDTypography from "../../../components/MyMDTypography";
import { T_partChange } from "../../../apis/partChange";


function ElevChange({elevatorNo}:any){
  //  console.log(elevatorNo);
    const nav = useNav();
    const [data,setData] = useState<T_partChange[]>([]);
      const getElevatorError = async() => {
          const result = await apis.partChange.getList({elevatorNo:elevatorNo,page:1,pagesize:3});
          console.log("result:",result);
          if(result.isSuccess){
              setData(result.partChangeList);
          }
  
      }

    useEffect(()=>{
        getElevatorError();
    },[])  
    return(
        <MyTableStyle 
        style={{width:'100%',marginBottom:10}}
        header={{
          title: "최근교환현황",
          rightComponent: (
            <MyMDBox
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <MyMDButton
                onClick={(evt: any) => {
                  evt.preventDefault();
                  nav.push(`/elevator/create`);
                }}
                href="#"
                component="a"
                rel="noreferrer"
                variant="gradient"
                color="light"
              >
                교환더보기
              </MyMDButton>
            </MyMDBox>
          ),
        }}
        table={(() => {
          type column = "메모" | "일시";
          type low = {
            [name in column]: JSX.Element;
          };
          const columnList: column[] = [
            "메모",
            "일시",
          ];

          return {
            columns: columnList.map((column) => {
              let width = "";
              switch (column) {
                case "메모": {
                  width = "40%";
                  break;
                }
                case "일시": {
                  width = "30%";
                  break;
                }
              }

              return {
                Header: column,
                accessor: column,
                width,
              };
            }),
            rows: data && data.map((change, idx) => {
              const row: low = {

                ["메모"]: (
                  <MyMDTypography
                    display="block"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    {change.content}
                  </MyMDTypography>
                ),
                ["일시"]: (
                  <MyMDTypography
                    display="block"
                    variant="caption"
                    fontWeight="regular"
                    color="text"
                  >
                    {change.insDate}
                  </MyMDTypography>
                )
              };
              return row;
            }),
          };
        })()}
      />                 


    )
}
export default ElevChange;
